import React from 'react';
import { configureEcho } from '@laravel/echo-react';
import apiClient from '@api/axios';
import { isDebug } from '@helpers/envHelper';

let configured = false;

export const useConfigureEcho = () => {
  if (configured) return;

  configured = true;

  if (isDebug()) {
    console.log(
      `Configuring Echo with ${import.meta.env.VITE_REVERB_SCHEME}://${
        import.meta.env.VITE_REVERB_HOST
      }:${import.meta.env.VITE_REVERB_PORT}..`
    );
  }

  configureEcho({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT,
    forceTLS: import.meta.env.VITE_REVERB_SCHEME === 'https',
    disableStats: true,
    authEndpoint: `${import.meta.env.VITE_API_HOST}/${import.meta.env.VITE_REVERB_AUTH_ENDPOINT}`,
    authorizer: (channel, options) => {
      return {
        authorize: (socketId, callback) => {
          apiClient
            .post('/broadcasting/auth', {
              socket_id: socketId,
              channel_name: channel.name,
            })
            .then((response) => {
              callback(null, response.data);
            })
            .catch((error) => {
              callback(
                new Error(error.message ?? 'Authorization failed'),
                error
              );
            });
        },
      };
    },
  });
};
